import ApiService from "../ApiService";

export default class TransactionDeliveryService {
  static getTransactionDeliveryGroup = async (params) => {
    let num, date_start, date_end, cursor, progress, keyword;

    num = `?num=20`;
    if (params.num && params.num !== "") {
      num = `?num=${params.num}`;
    }
    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }
    if (params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }
    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction/delivery_group${num}${cursor || ""}${date_start || ""}${
        date_end || ""
      }${progress || ""}${keyword || ""}`
    );
  };

  static getTransactionDeliveryGroupSummary = async (params) => {
    let date_start, date_end, progress, keyword;

    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction/delivery_group/summary?${date_start || ""}${
        date_end || ""
      }${progress || ""}${keyword || ""}`
    );
  };

  static downloadTransactionDelivery = async (params) => {
    let date_start, date_end, progress, keyword;

    if (params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.progress !== "") {
      progress = `&progress=${params.progress}`;
    }
    if (params.date_start && params.date_start !== "") {
      date_start = `&date_start=${params.date_start}`;
    }
    if (params.date_end && params.date_end !== "") {
      date_end = `&date_end=${params.date_end}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/transaction/delivery_group/download?${date_start || ""}${
        date_end || ""
      }${progress || ""}${keyword || ""}`
    );
  };

  static postManualNotify = async (params) => {
    const instance = await ApiService();
    return instance.post(`/delivery/notify/manual`, params)
  }
}
